import React from "react";
import useRoute from "hooks/useRoute";
import { useHistory } from "react-router-dom";
import { PATHS } from "constants/Constants";
import {
	successAlertCustom,
	confirmDeleteMessage,
	deleteFailAlertWithText,
} from "utils/alertUtils";
import shallow from "zustand/shallow";
import { Button } from "reactstrap";
import { deleteAccount } from "./AccountAPI";
import useCurrentAccountStore from "./AccountStore";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";

export const AccountDeleteButton = () => {
	const history = useHistory();
	const newRoute = useRoute(PATHS.ACCT_LIST);
	const privileges = useUserBhphPrivileges();
	const p = privileges();
	const hasPermission = p.deleteAccount;
	const { account, payments } = useCurrentAccountStore(
		(state) => ({
			account: state.account,
			payments: state.payments,
		}),
		shallow
	);

	const DeleteAccount = async () => {
		let answer = "Cancel";
		if (payments.length > 0) {
			//			answer = await confirmDeleteAcctMessage("Yes, Delete it");
			answer = await confirmDeleteMessage("Yes, Delete it");
		} else {
			answer = await confirmDeleteMessage("Yes, Delete it");
		}
		if (answer === "Yes, Delete it") {
			deleteAccount(account.id).then(
				(res) => {
					console.log(res);
					console.log(newRoute);

					successAlertCustom("Your account has been  deleted.");
					history.push(newRoute);
				},
				(error) => {
					if (!error.isGeneralError) {
						deleteFailAlertWithText(error?.response?.data?.message);
					}
				}
			);
		}
	};

	return (
		<Button
			className="btn-md btn btn-danger"
			onClick={() => DeleteAccount()}
			disabled={!hasPermission}
		>
			<i className="nc-icon nc-simple-remove"></i> Delete Account
		</Button>
	);
};

export default AccountDeleteButton;
